// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607140323/js/" + chunkId + "." + {"44":"aed46c30","225":"49878155","481":"aeb6f54b","486":"7929a382","770":"aa79a9e0"}[chunkId] + ".0.6300710699250627.chunk.js";
};